import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import HeaderStyles from "../../Styles/ChannelViewer/Header.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import NewChannelModal from "./NewChannelModal";
import { ContextForClient } from "../../Context_file/ClientContext";
import DropDownModal from "./DropDownModal";
import JoinChannelModal from "./JoinChannelModal";

const Header = () => {
  const { container, heading } = HeaderStyles;
  const [{ resizeFlag }, dispatch] = useContext(ContextForClient);

  const displayDropDown = async () => {
    await dispatch({ type: "SHOW_DROP_DOWN", payload: true });
  };

  return (
    <>
      {resizeFlag && (
        <div className={`container d-flex  ${container}`}>
          <section className={heading} style={{ transform: "translateY(20%)" }}>
            <h4 className="text-capitalize">channels</h4>
          </section>

          <section>
            <FontAwesomeIcon
              icon={faPlusSquare}
              size="2x"
              color="#ccc"
              cursor="pointer"
              onClick={() => displayDropDown()}
            />
          </section>

          <NewChannelModal />
          <DropDownModal />
          <JoinChannelModal />
        </div>
      )}
    </>
  );
};

export default Header;
